/**
 * Import Dependency
 */
import config from '@/../shared/deployment-config'



/**
 * Import API
 */

const CONFIG_DEFAULT = {
  code: null,
  emailAddressSupport: 'support@evtools.nl',
  prognoseModels: [],
}


/**
 * Declare Variable
 */
const state = {
  deployment: process.env.VUE_APP_DEPLOYMENT || 'nl',
  mapbox: process.env.VUE_APP_MAPBOX_ACCOUNT || 'evtools',
}

/*
* Layers are deactivated if they are set to false in the config.
*
* If there is only true set for a layer, the name will be auto-generated.
*
* If there is a string set, the string will be used to load the data.
*/
const getters = {
  MapboxAccount: state => state.mapbox,
  DeploymentCode: state => config[state.deployment].code,

  DeploymentHasLayer: state => ({ layer }) => !!(config[state.deployment].layers[layer] || false),
  DeploymentLayerName: (state, getters) => ({ layer, scope }) => {
    try {
      let layername = config[state.deployment].layers[layer]
      scope = scope || 'l'

      if (layername === true) {
        return `${getters.DeploymentCode}_${scope}_${layer}`
      }
      return layername || false
    } catch (e) {
      return false
    }
  },

  DeploymentConfig: state => {
    return config[state.deployment] || CONFIG_DEFAULT
  },

  getEmailAddressSupport: state => {
    return config[state.deployment].emailAddressSupport || 'support@evtools.nl'
  },
  getThresholdFastchargerInKw: state => {
    return config[state.deployment].thresholdFastChargerInKw || '23000'
  },
  getThresholdConnectionPointsForChargingHub: state => {
    return config[state.deployment].thresholdConnectionPointsForChargingHub || 2
  },
  getPrognoseModels: state => {
    return config[state.deployment].prognoseModels || []
  },
}
const actions = {}
const mutations = {}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
